/* Only reset navigation and actual rendered product filters. No cart or product-form interception. */
(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-reset-home]').forEach(home => {
      if (home.dataset.resetReady) return;
      home.dataset.resetReady = 'true';
      const buttons = [...home.querySelectorAll('[data-filter]')];
      const cards = [...home.querySelectorAll('.home-products [data-topic]')];
      const status = home.querySelector('.reset-filter-status');
      // Keep every family in the DOM; cap the matching set, never the source set.
      function applyFilter(topic) {
        const matching = cards.filter(card => topic === 'all' || card.dataset.topic === topic);
        const shown = matching.slice(0, 4);
        cards.forEach(card => { card.hidden = !shown.includes(card); });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === topic)));
        if (status) status.textContent = `${shown.length} von ${matching.length} Produkten in dieser Auswahl`;
      }
      buttons.forEach(button => {
        if (button.dataset.filter !== 'all' && !cards.some(card => card.dataset.topic === button.dataset.filter)) {
          button.hidden = true;
          return;
        }
        button.addEventListener('click', () => applyFilter(button.dataset.filter));
      });
      applyFilter('all');
    });
    root.querySelectorAll('[data-reset-sort]').forEach(select => {
      if (select.dataset.resetReady) return;
      select.dataset.resetReady = 'true';
      const grid = select.closest('.pic-curated').querySelector('.reset-curated-grid');
      if (!grid) return;
      const original = [...grid.children];
      select.closest('[data-reset-sort-control]').hidden = false;
      select.addEventListener('change', () => {
        const sorted = [...original];
        if (select.value !== 'recommended') {
          const direction = select.value === 'price-descending' ? -1 : 1;
          sorted.sort((a, b) => direction * (Number(a.querySelector('[data-price]').dataset.price) - Number(b.querySelector('[data-price]').dataset.price)));
        }
        sorted.forEach(card => grid.append(card));
      });
    });
    root.querySelectorAll('.reset-header-shell details').forEach(menu => {
      if (menu.dataset.resetReady) return;
      menu.dataset.resetReady = 'true';
      menu.addEventListener('toggle', () => {
        const summary = menu.querySelector('summary');
        summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) root.querySelectorAll('.reset-header-shell details').forEach(other => { if (other !== menu && !other.contains(menu)) other.open = false; });
      });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.reset-header-shell details[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.reset-header-shell details[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.reset-header-shell details[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  setup();
})();
